import React from 'react';
import Button from '@mui/material/Button';
import { ThemeProvider } from '@mui/material/styles';
import buttonTheme from './buttonTheme';
interface IProps {
  variant?: 'text' | 'outlined' | 'contained';
  size?: 'small' | 'medium' | 'large';
  type?: 'submit' | 'button';
  id?: string;
  cName?: string;
  style?: any;
  startIcon?: any;
  endIcon?: any;
  onClick?: any;
  onMouseEnter?: any;
  onMouseLeave?: any;
  onMouseOver?: any;
  onMouseOut?: any;
  disabled?: boolean;
  children?: any;
}

const CustomButton = ({
  variant,
  size,
  type,
  id,
  cName,
  style,
  startIcon,
  endIcon,
  onClick,
  onMouseEnter,
  onMouseLeave,
  onMouseOver,
  onMouseOut,
  disabled,
  children,
  ...rest
}: IProps) => {
  return (
    <ThemeProvider theme={buttonTheme}>
      <Button
        id={id ? id : ''}
        className={cName ? cName : ''}
        type={type ? type : 'button'}
        variant={variant ? variant : null}
        size={size}
        startIcon={startIcon ? startIcon : null}
        endIcon={endIcon ? endIcon : null}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
        sx={{ ...style }}
        style={{ color: style?.color }}
        disabled={disabled ? disabled : false}
        {...rest}>
        {children}
      </Button>
    </ThemeProvider>
  );
};

export default CustomButton;
